import { GetCurrentUserDetails } from "@/graphql/queries.js";
import { generateClient } from "aws-amplify/api";
import { signOut } from "aws-amplify/auth";
const client = generateClient();
export const GetCurrentUserDetailsQuery = {
  data() {
    return {
      overlay: false,
      GetCurrentUserDetailsObject: {},
    };
  },
  methods: {
    async GetCurrentUserDetailsMethod() {
      try {
        this.overlay = true;
        this.GetCurrentUserDetailsObject = {};
        let result = await client.graphql({
          query: GetCurrentUserDetails,
          variables: {
            input: {
            user_email_id: this.$store.getters.get_user_email,
          },
          }
        });
        this.GetCurrentUserDetailsObject = JSON.parse(
          result.data.GetCurrentUserDetails,
        ).data.items[0];
        this.$store.commit(
          "SET_CURRENTUSER_DETAILS",
          this.GetCurrentUserDetailsObject,
        );
        if (
          this.$route.name != "Organizations" &&
          this.$route.name == "LandingPage"
        ) {
          this.RouterList[0].active = true;
          this.$router.push("Organizations");
        }
        this.overlay = false;
      } catch (error) {
        console.log(error);
        this.GetCurrentUserDetailsObject = {};
        this.overlay = false;
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: "Something Went Wrong!! Logging Out!!",
        };
        try {
          await signOut();
        } catch (signOutError) {
          console.log(signOutError);
        }
        setTimeout(() => {
          this.$router.push("/");
        }, 2000);
      }
    },
  },
};
